import { AirplaneTakeoff, ChatCircleText, Receipt } from '@phosphor-icons/react'
import { motion } from 'framer-motion'

const STEPS = [
  {
    icon: ChatCircleText,
    title: 'Cuéntanos a dónde',
    body: 'Llena el cotizador o escríbenos por WhatsApp con fechas y cuántos viajan.',
  },
  {
    icon: Receipt,
    title: 'Te cotizamos en 24 horas',
    body: 'Un asesor de Despega arma dos o tres opciones con precio final, sin letra pequeña.',
  },
  {
    icon: AirplaneTakeoff,
    title: 'Vuelas con todo resuelto',
    body: 'Boletos, hotel y traslados en un solo lugar, y tu asesor disponible durante el viaje.',
  },
]

const ease = [0.16, 1, 0.3, 1]

export default function HowItWorks() {
  return (
    <section className="px-4 py-20 md:px-8 md:py-28">
      <div className="mx-auto max-w-7xl">
        <h2 className="max-w-2xl font-display text-3xl font-extrabold tracking-tight text-navy-950 md:text-5xl">
          Viajar bien no debería ser complicado.
        </h2>

        <ol className="relative mt-12 grid grid-cols-1 gap-10 md:grid-cols-3 md:gap-8">
          <div aria-hidden className="absolute left-0 right-0 top-7 hidden h-px bg-navy-900/10 md:block" />
          {STEPS.map((step, i) => (
            <motion.li
              key={step.title}
              initial={{ opacity: 0, y: 18 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.4 }}
              transition={{ duration: 0.55, ease, delay: i * 0.1 }}
              className="relative"
            >
              <div className="relative z-10 grid h-14 w-14 place-items-center rounded-2xl bg-sunset-500 text-white">
                <step.icon size={26} weight="fill" />
              </div>
              <h3 className="mt-5 font-display text-xl font-bold text-navy-950">{step.title}</h3>
              <p className="mt-2 max-w-[42ch] text-base leading-relaxed text-navy-700/60">{step.body}</p>
            </motion.li>
          ))}
        </ol>
      </div>
    </section>
  )
}
